import { Box, Spinner } from '@chakra-ui/react'
import { memo } from 'react'

const LoadingSpinner = memo(() => (
  <Box display="flex" justifyContent="center" py={10}>
    <Spinner size="xl" color="primary" />
  </Box>
))
LoadingSpinner.displayName = 'LoadingSpinner'

export default LoadingSpinner
